module.exports = __webpack_public_path__ + "img/login-yundian.810e04ca.jpg";